<template>
  <div>
    <b-table
      ref="test-table"
      class="test-table sticky-table complex-table"
      :min-width="tableWidth"
      responsive
      :items="items"
      :fields="fields"
      :currentTeachingMaterialTabName="currentTeachingMaterialTabName"
      :currentTeachingBookTabName="currentTeachingBookTabName"
      thead-class="d-none"
    >
      <template v-slot:cell(group)="row">
        <div class="circle divide-line-pre" :class="row.index == 0 ? 'circle-total' : ''">
          <span>{{ row.value }}</span>
        </div>
        <hr class="divide-line divide-line-pre" />
        <div v-for="content in row.item.results" :key="content.id" class="test-cell divide-line-pre">
          {{ testResultIdDisplay(content.id) }}
        </div>
      </template>

      <template v-slot:cell(title)="row">
        <div class="test-cell content-font-size">{{ row.value }}</div>
        <hr class="divide-line" />
        <template v-if="row.item.results.length">
          <template v-if="row.item.results">
            <div v-for="content in row.item.results" :key="content.id" class="test-cell">
              ・・・・・・
            </div>
          </template>
        </template>
        <template v-else>
          <div class="test-cell">受験履歴がありません</div>
        </template>
      </template>

      <template v-slot:cell(testDateTime)="row">
        <div class="test-cell"></div>
        <hr class="divide-line" />
        <div v-for="content in row.item.results" :key="content.id" class="test-cell">
          {{ content.testDateTime }}
        </div>
      </template>

      <template v-slot:cell(testScore)="row">
        <div class="test-cell"></div>
        <hr class="divide-line" />
        <div v-for="content in row.item.results" :key="content.id" class="test-cell">
          {{ testResultScoreDisplay(content.testScore) }}
        </div>
      </template>

      <template v-slot:cell(comment)="row">
        <div class="test-cell"></div>
        <hr class="divide-line" />
        <div v-for="content in row.item.results" :key="content.id" class="test-cell">{{ content.comment }}</div>
      </template>

      <template v-slot:cell(teacherName)="row">
        <div class="test-cell"></div>
        <hr class="divide-line" />
        <div v-for="content in row.item.results" :key="content.id" class="test-cell">{{ content.name }}</div>
      </template>

      <template v-slot:cell(action)="row">
        <div class="test-cell"></div>
        <hr class="divide-line divide-line-post" />
        <div v-for="content in row.item.results" :key="content.id" class="test-cell">
          <template v-if="content.wrongAnswer">
            <a class="hyper-text" @click="showWrongAnswerImages(row.item, content)">間違えた問題を見る</a>
          </template>
        </div>
      </template>
    </b-table>

    <PopUpHolder ref="popup_holder" no-close-on-esc no-close-on-backdrop custom-footer popup-size="xl">
      <template v-slot:header>
        <div>間違えた問題</div>
        <span class="book-popup-header">{{ currentTeachingMaterialTabName }} {{ currentTeachingBookTabName }}</span>
        <span class="book-popup-header">{{ currentGroupTitle }}</span>
        <span class="book-popup-header">{{ currentTestResultId }}</span>
        <span class="book-popup-header">{{ currentTestResultDatetime }}</span>
        <span class="book-popup-header">{{ currentTestResultScore }}</span>
        <span class="book-popup-header">{{ currentTestResultComment }}</span>
        <button type="button" class="btn btn-gray-round float-right" @click="hidePopup">閉じる</button>
      </template>
      <template v-slot:body>
        <button class="btn btn-gray wide-btn" @click="toggleShowChoice">
          {{ showChoice ? '選んだ解答を非表示' : '選んだ解答を表示' }}
        </button>
        <b-table
          :min-width="tableImageURLWidth"
          responsive
          :items="wrongAnswerImages"
          :fields="imageURLFields"
          thead-class="d-none"
        >
          <template v-slot:cell(imageDetail)="row">
            <div class="circle-wrong-answer-id">
              <span>{{ row.item.id }}</span>
            </div>
            <div>
              <div class="image-holder">
                <img
                  class="image-url-holder"
                  :src="row.item.imageURLs.txt1ImageURL"
                  v-if="row.item.imageURLs.txt1ImageURL"
                />
              </div>
              <div class="image-holder">
                <img
                  class="image-url-holder"
                  :src="row.item.imageURLs.img1ImageURL"
                  v-if="row.item.imageURLs.img1ImageURL"
                />
              </div>
              <div class="image-holder">
                <img
                  class="image-url-holder"
                  :src="row.item.imageURLs.txt2ImageURL"
                  v-if="row.item.imageURLs.txt2ImageURL"
                />
              </div>
              <div class="choice" v-show="showChoice">
                <p>選んだ解答</p>
                <img
                  class="image-url-holder choiceImg"
                  :class="'format_' + row.item.imageURLs.format"
                  :src="row.item.imageURLs.wrongAnswerImageURL"
                  v-if="row.item.imageURLs.wrongAnswerImageURL"
                />
                <p v-else>なし</p>
              </div>
            </div>
          </template>
        </b-table>
      </template>
      <template v-slot:footer><div></div></template>
    </PopUpHolder>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { sumObjectArrayByKey } from '@/utils/math_helpers.js';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    currentTeachingMaterialTabName: {
      type: String,
      required: false,
    },
    currentTeachingBookTabName: {
      type: String,
      required: false,
    },
  },
  components: {
    PopUpHolder,
  },
  data() {
    const currentGroup = '';
    const currentTestResult = '';
    const imageURLFields = [
      {
        key: 'imageDetail',
      },
    ];
    return {
      currentGroup,
      currentTestResult,
      imageURLFields,
      showChoice: true,
    };
  },
  computed: {
    currentGroupTitle() {
      return this.currentGroup.title;
    },
    currentTestResultId() {
      const testId = this.currentTestResult.id;
      return this.testResultIdDisplay(testId);
    },
    currentTestResultDatetime() {
      return this.currentTestResult.testDateTime;
    },
    currentTestResultScore() {
      const testScore = this.currentTestResult.testScore;
      return this.testResultScoreDisplay(testScore);
    },
    currentTestResultComment() {
      return this.currentTestResult.comment;
    },
    tableWidth() {
      return sumObjectArrayByKey(this.fields, 'tdAttr', 'width') + 'px';
    },
    tableImageURLWidth() {
      return sumObjectArrayByKey(this.imageURLFields, 'tdAttr', 'width') + 'px';
    },
    ...mapState({
      wrongAnswerImages: (state) => state.student_history.wrongAnswerImages,
    }),
  },
  methods: {
    showWrongAnswerImages(group, testResult) {
      this.fetchWrongAnswerImages(testResult.wrongAnswer).then(() => {
        this.currentGroup = group;
        this.currentTestResult = testResult;
        this.$refs['popup_holder'].show();
      });
    },
    testResultIdDisplay(testId) {
      return testId + '回目';
    },
    testResultScoreDisplay(testScore) {
      return testScore + '点';
    },
    hidePopup() {
      this.$refs['popup_holder'].hide();
      this.showChoice = true;
    },
    ...mapActions('student_history', ['fetchWrongAnswerImages']),
    toggleShowChoice() {
      this.showChoice = !this.showChoice;
    },
  },
};
</script>

<style scoped>
.circle-total {
  background-color: #42b195;
}
.wide-btn {
  font-size: 12px;
  height: 22.7px;
  padding: 1px 13px 5px 13px;
}
.circle-wrong-answer-id {
  font-size: 20px;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  line-height: 50px;
  text-align: center;
  background-color: #6b5df9;
  color: white;
}
.choice {
  font-size: 20px;
}
.choiceImg {
  width: 250px;
}
.format_f1 {
  width: 200px;
}
.format_f3 {
  width: 150px;
}
.format_f4 {
  width: 450px;
}
.format_tf3 {
  width: 300px;
}
.format_tf4,
.format_tf5,
.format_tf6 {
  width: 200px;
}
.format_tf7,
.format_tf8 {
  width: 150px;
}
.format_tf9 {
  width: 450px;
}

.test-cell {
  height: 30px;
}
.hyper-text {
  color: #227afa;
  cursor: pointer;
}
.book-popup-header {
  margin-right: 40px;
}
.image-icon-metro-cross {
  vertical-align: top;
}
.image-holder > .image-url-holder {
  width: 700px;
}
.image-url-holder {
  margin-bottom: 10px;
}
.content-font-size {
  font-size: 11.5px;
  line-height: 1.2em;
}
</style>
